module.exports = __webpack_public_path__ + "static/media/home_simulacao_mobile.5187ef18.png";